import React from 'react';
import Flags from 'country-flag-icons/react/3x2';
import Btn from 'components/Btn';
import * as UIcons from '@iconscout/react-unicons';

export default function CountrySelection({handleClick}) {
  return (
    <div className="fixed lg-hidden flex top-0 left-0 bg-black bg-opacity-30 z-50 w-full h-full">
      <div className="w-11/12 m-auto bg-white rounded-xl divide-y px-4">
        <div className="flex w-full p-4 px-7 items-center relative">
          <h3 className="text-2xl font-bold">Choose Profile</h3>

          <Btn 
            className="w-10 h-10 bg-transparent hover:bg-transparent absolute right-2 top-1"
            content={ () => <UIcons.UilTimes className="text-secondary" /> }
            click={ handleClick }
          />
        </div>

        <ul className="">
          <li className="flex w-full p-3 px-7 items-center cursor-pointer">
            <Flags.NG title="Nigeria" className="w-8 h-8 pr-2" />
            <label className="">Nigeria</label>
          </li>
          <li className="flex w-full p-3 px-7 items-center cursor-pointer">
            <Flags.GH title="Ghana" className="w-8 h-8 pr-2" />
            <label className="">Ghana</label>
          </li>
          <li className="flex w-full p-3 px-7 items-center cursor-pointer">
            <Flags.TG title="Togo" className="w-8 h-8 pr-2" />
            <label className="">Togo</label>
          </li>
        </ul>
      </div>
    </div>
  )
}
